// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"Tile_mapWrapper__7Moow"};